module.exports = __webpack_public_path__ + "static/jarritos-dfb3d3d900af059a0748177dae0c293e.png";